import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IsNotCalibratedReasonService } from 'src/app/core/services/is-not-calibrated-reason.service';
import { NotificationMessageService } from 'src/app/core/services/notification-message.service';
import { IZoneCombinationModel } from 'src/app/interfaces/zone-combination-model.interface';
import { NotificationMessageType } from 'src/shared/enums/notification-message-type.enum';
import IIsNotCalibratedReason = ZoneIQCalibration.IIsNotCalibratedReason;
import * as _ from 'lodash';
import { Subscription } from 'rxjs';

@Component({
    standalone: false,
    selector: 'ziq-zone-combination',
    templateUrl: './zone-combination.component.html',
    styleUrls: ['./zone-combination.component.scss']

})
export class ZoneCombinationComponent implements OnInit, OnDestroy {
    @Input()
    zoneCombination: IZoneCombinationModel;

    IS_NOT_CALIBRATED: string;
    IS_NOT_CALIBRATED_PLANNED_DEVELOPMENT: string;

    reasons: IIsNotCalibratedReason[] = [];
    selectedReasons: number[] = [];
    reasonsSubscription: Subscription;

    selectedAll: boolean;
    private lastIsNotCalibrated: boolean;

    constructor(
        private readonly notificationMessageService: NotificationMessageService,
        private readonly isNotCalibratedReasonService: IsNotCalibratedReasonService
    ) {
        this.IS_NOT_CALIBRATED = this.notificationMessageService.getMessageByType(
            NotificationMessageType.IS_NOT_CALIBRATED
        );
        this.IS_NOT_CALIBRATED_PLANNED_DEVELOPMENT = this.notificationMessageService.getMessageByType(
            NotificationMessageType.IS_NOT_CALIBRATED_PLANNED_DEVELOPMENT
        );
    }

    ngOnInit() {
        this.reasonsSubscription = this.isNotCalibratedReasonService.isNotCalibratedReasons.subscribe(reasons => {
            this.reasons = reasons || [];
        });
        this.lastIsNotCalibrated = !!_.get(this, 'zoneCombination.currentState.IsNotCalibrated', false);
        this.selectedReasons = (_.get(this, 'zoneCombination.IsNotCalibratedReason', []) as IIsNotCalibratedReason[])
            .filter(reason => reason)
            .map(reason => reason.Id);
    }

    ngOnDestroy() {
        if (this.reasonsSubscription) {
            this.reasonsSubscription.unsubscribe();
        }
    }

    selectAll() {
        this.selectedAll = !this.selectedAll;
        this.selectedReasons = this.selectedAll ? this.reasons.map(reason => reason.Id) : [];
        this.listChanged();
    }

    onIsNotCalibratedChange(isNotCalibrated: boolean) {
        if (!this.lastIsNotCalibrated && isNotCalibrated) {
            this.selectedReasons = this.reasons
                .filter(reason => reason.IsDefault)
                .map(reason => reason.Id);
            this.listChanged();
        }

        this.lastIsNotCalibrated = isNotCalibrated;
    }

    listChanged() {
        if (!_.get(this, 'zoneCombination.currentState')) {
            return;
        }
        this.zoneCombination.currentState.IsNotCalibratedReason = this.reasons.filter(
            reason => this.selectedReasons.indexOf(reason.Id) >= 0
        );
    }
}
